export enum DetalhesOrdemCargaTypes {
  'LOAD_REQUEST' = '@detalhesOrdemCarga/LOAD_REQUEST',
  'LOAD_SUCCESS' = '@detalhesOrdemCarga/LOAD_SUCCESS',
  'LOAD_FAILURE' = '@detalhesOrdemCarga/LOAD_FAILURE',

  'CLEAR_DETALHES_ORDEMCARGA' = '@detalhesOrdemCarga/CLEAR_DETALHES_ORDEMCARGA',
}

export interface Pedidos {
  nuNota: number;
  numNota: number;
  codFornecedor: number;
  codDestinatario: number;
  pesoBruto: number;
  valor: number;
  destinatario: string;
  fornecedor: string;
  observacao: string;
  cidadeOrigem: string;
  qtdVolume: number;
  tipoVolume: string;
  nunotaEmitida: number;
  produto: string;
  nomeCD: string;
  temAnexo: number;
}

export interface DetalhesOrdemCarga {
  codEmp: number;
  ordemCarga: number;
  codMotorista: number;
  codVeiculo: number;
  codDestinatario: number;
  clienteRetira: boolean;
  tipoCarga: string;
  assoalho: string;
  codTransportadora: number;
  codTipoCarroceria: number;
  status: string;
  tipoWms: string;
  placa: string;
  cpfMotorista: string;
  motorista: string;
  pesoTotal: number;
  vlrTotal: number;
  transportadora: string;
  destinatario: string;
  agendavel: boolean;
  tipVei: string;
  codCdd: number;
  nomeCdd: string;

  pedidos: Pedidos[];
}

export interface DetalhesOrdemCargaState {
  readonly data: DetalhesOrdemCarga | undefined;
  readonly loading: boolean;
  readonly error: boolean;
}
